import { SubscriptionState } from '@batical/types/src'
import { SubscriptionType } from './SubscriptionType'

export const loadSubscription = (subscription: SubscriptionState) => {
  return {
    type: SubscriptionType.INIT_SUBSCRIPTION,
    payload: { data: subscription }
  }
}

export const updateExpirationDate = (expirationDate: number, platform: string) => {
  return {
    type: SubscriptionType.UPDATE_EXPIRATION,
    payload: { expirationDate, platform }
  }
}
